import { getSessionStatus as ownerGetStatus, checkNumber as ownerCheckNumber } from "../whatsapp/ownerWhatsAppApi";
import { getSessionStatus as portalGetStatus, checkNumber as portalCheckNumber } from "../whatsapp/portalWhatsAppApi";

/** Normalize WA session status to CONNECTED | DISCONNECTED | CONNECTING */
export const normalizeWaStatus = (raw) => {
  const s = String(raw || "DISCONNECTED").toUpperCase();
  if (s === "CONNECTED" || s === "OPEN" || s === "READY") return "CONNECTED";
  if (s === "CONNECTING" || s === "PAIRING" || s === "QR" || s === "PENDING") return "CONNECTING";
  return "DISCONNECTED";
};

export const fetchWhatsAppAppStatus = async (isPortal = false) => {
  try {
    const res = isPortal ? await portalGetStatus() : await ownerGetStatus();
    const status = normalizeWaStatus(res?.status || res?.data?.status);
    return {
      success: true,
      channel: "WHATSAPP",
      status,
      raw: res,
    };
  } catch (err) {
    return {
      success: false,
      channel: "WHATSAPP",
      status: "DISCONNECTED",
      error: err.response?.data?.message || err.message,
    };
  }
};

/**
 * Checks whether a phone number is registered on WhatsApp, via the school's
 * live Baileys socket. Backend returns { success, phone, exists, jid }.
 */
export const checkWhatsAppNumber = async (phoneNumber, isPortal = false) => {
  const res = isPortal
    ? await portalCheckNumber(phoneNumber)
    : await ownerCheckNumber(phoneNumber);
  return {
    exists: !!(res?.exists ?? res?.data?.exists),
    jid: res?.jid || res?.data?.jid || null,
    phone: res?.phone || res?.data?.phone || phoneNumber,
  };
};

/** Static catalog — SMS/Email not functional yet */
export const NOTIFICATION_APPS = [
  {
    id: "whatsapp",
    channel: "WHATSAPP",
    name: "WhatsApp",
    description: "Send fee reminders and receipts via WhatsApp (Baileys).",
    connectPath: "/owner/whatsapp",
    connectPathPortal: "/portal/whatsapp",
    functional: true,
  },
  {
    id: "sms",
    channel: "SMS",
    name: "SMS",
    description: "Send SMS notifications. Setup coming soon.",
    connectPath: null,
    functional: false,
  },
  {
    id: "email",
    channel: "EMAIL",
    name: "Email",
    description: "Send email notifications. Setup coming soon.",
    connectPath: null,
    functional: false,
  },
];